import { ReactNode } from 'react'

export enum FieldGroupColor {
  Danger = 'danger',
  Help = 'help',
  Warning = 'warning',
  Success = 'success',
  Default = 'default',
  Transparent = 'transparent',
}

export enum FieldGroupRounded {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  None = 'none',
}

export interface IFieldGroupProps extends ICollapsible {
  color?: FieldGroupColor
  /* Field group is hidden or not */
  isHidden?: boolean
  /* Title of field group */
  title?: ReactNode
  /* Number of columns. Default: 3 */
  size?: number
  /* Rounded: 6px, 8px, 12px */
  rounded?: FieldGroupRounded
  /* Has border? */
  hasBorder?: boolean

  classNames?: TFieldGroupClassNames
}

export interface ICollapsible {
  isCollapsible?: boolean
  isCollapsed?: boolean
  keepMounted?: boolean
  hasScrollTo?: boolean
}

type TFieldGroupClassNames = {
  group?: string
  groupTitle?: string
  groupFields?: string
}
